"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsSectionHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Checkbox_1 = __importDefault(require("@atg/icf-react-components/components/Checkbox"));
var FlatButton_1 = __importDefault(require("@atg/icf-react-components/components/FlatButton"));
var Popover_1 = __importDefault(require("@atg/icf-react-components/components/Popover"));
var SvgIcon_1 = __importDefault(require("@atg/icf-react-components/components/SvgIcon"));
var Tabs_1 = __importStar(require("@atg/icf-react-components/components/Tabs"));
var Text_1 = __importDefault(require("@atg/icf-react-components/components/Text"));
var Tooltip_1 = __importStar(require("@atg/icf-react-components/components/Tooltip"));
var Theme_1 = require("@atg/icf-react-components/themes/Theme");
var SearchFilters_1 = require("icf-search-client-data/lib/SearchFilters");
var OnlineOfflineMode_1 = require("icf-search-client-shared/lib/constants/OnlineOfflineMode");
var EqualityComparers_1 = require("icf-search-client-shared/lib/EqualityComparers");
var Events_1 = require("icf-search-client-shared/lib/services/Events");
var react_1 = __importDefault(require("react"));
var react_jss_1 = __importDefault(require("react-jss"));
var FilterPillHeaderContainer_1 = require("../../react/components/FilterPillHeaderContainer");
var AdvancedFilter_1 = require("../utilities/AdvancedFilter");
var HiddenText_1 = require("./HiddenText");
var SearchResultsCategoryScroller_1 = __importDefault(require("./SearchResultsCategoryScroller"));
var SearchResultsSectionHeaderMessage_1 = require("./SearchResultsSectionHeaderMessage");
var SearchResultsSectionThumbnails_1 = require("./SearchResultsSectionThumbnails");
var ShowOfflineButtonContainer_1 = require("./ShowOfflineButtonContainer");
// TODO: A lot of coverage was being missed by earlier earlier Jest version is my best guess. Some of these are false positives now, though.
var HeaderFilter;
(function (HeaderFilter) {
    HeaderFilter["REGION"] = "region";
    HeaderFilter["AGE"] = "age";
    HeaderFilter["FEATURE"] = "feature";
    HeaderFilter["ETHNICITY"] = "ethnicity";
    HeaderFilter["FETISHES"] = "fetishes";
    HeaderFilter["LANGUAGES"] = "languages";
})(HeaderFilter || (HeaderFilter = {}));
var CATEGORY_GROUP_TO_HIDE = "friendsnonnude";
var HeaderWrapper = (0, react_jss_1.default)(function (theme) { return ({
    headerWrapper: function (_a) {
        var isLarge = _a.isLarge, isFirstGrid = _a.isFirstGrid, showFiltersOnNewline = _a.showFiltersOnNewline;
        return ({
            display: "flex",
            alignItems: isLarge ? "flex-start" : "center",
            flexDirection: isLarge && showFiltersOnNewline ? "column" : "row",
            justifyContent: "space-between",
            gap: theme.spacing.base,
            marginLeft: isLarge ? 0 : "8px",
            marginRight: isLarge ? 0 : "8px",
            marginTop: isFirstGrid || !isLarge ? "inherit" : theme.spacing.base * 3,
            paddingTop: isFirstGrid || !isLarge ? "inherit" : theme.spacing.base,
            borderTop: isFirstGrid || !isLarge ? "none" : "1px solid ".concat(theme.colors.baseContrast030),
            // Styles to accomodate iPhoneX screen specs
            // (https://webkit.org/blog/7929/designing-websites-for-iphone-x/)
            "@supports (padding: env(safe-area-inset-left))": {
                // eslint-disable-next-line @atg/css-rtl-support
                paddingLeft: "env(safe-area-inset-left)",
                // eslint-disable-next-line @atg/css-rtl-support
                paddingRight: "env(safe-area-inset-right)",
            },
        });
    },
}); })(function (_a) {
    var classes = _a.classes, isLarge = _a.isLarge, isFirstGrid = _a.isFirstGrid, showFiltersOnNewline = _a.showFiltersOnNewline, props = __rest(_a, ["classes", "isLarge", "isFirstGrid", "showFiltersOnNewline"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.headerWrapper }, props)));
});
var HeaderFiltersContainer = (0, react_jss_1.default)({
    headerFiltersContainer: function (_a) {
        var isLarge = _a.isLarge, showFiltersOnNewline = _a.showFiltersOnNewline;
        return (__assign({}, (isLarge && showFiltersOnNewline && { width: "100%" })));
    },
})(function (_a) {
    var classes = _a.classes, isLarge = _a.isLarge, showFiltersOnNewline = _a.showFiltersOnNewline, props = __rest(_a, ["classes", "isLarge", "showFiltersOnNewline"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.headerFiltersContainer }, props)));
});
var NoResultsMessage = (0, react_jss_1.default)({
    noResultsMessage: function (_a) {
        var isLarge = _a.isLarge;
        return ({
            fontSize: "16px",
            margin: isLarge ? 0 : "10px 8px",
        });
    },
})(function (_a) {
    var classes = _a.classes, isLarge = _a.isLarge, props = __rest(_a, ["classes", "isLarge"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.noResultsMessage }, props));
});
var DesktopFiltersContainer = (0, react_jss_1.default)(function (theme) { return ({
    desktopFiltersContainer: function (_a) {
        var showFiltersOnNewline = _a.showFiltersOnNewline;
        if (!showFiltersOnNewline) {
            return {};
        }
        return {
            display: "flex",
            flexBasis: "100%",
            flexDirection: "row",
            minHeight: "38px",
            marginBottom: theme.spacing.base * 1.25,
            marginTop: theme.spacing.base * 0.75,
            "& .flatButtonRoot": {
                zIndex: 1600,
                "& > svg": {
                    fill: theme.colors.primary,
                },
            },
            "& .flatButtonLabel": {
                textTransform: "initial",
            },
            "& .popoverRoot": {
                top: "initial",
                // eslint-disable-next-line @atg/css-rtl-support
                left: "initial",
                margin: 0,
            },
            "& .popoverContent": {
                background: theme.colors.themeBase,
                paddingBottom: theme.spacing.base / 2,
            },
            "& .popoverTriangle": {
                display: "none",
            },
        };
    },
}); })(function (_a) {
    var classes = _a.classes, showFiltersOnNewline = _a.showFiltersOnNewline, props = __rest(_a, ["classes", "showFiltersOnNewline"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.desktopFiltersContainer }, props)));
});
var DesktopFiltersSpacer = (0, react_jss_1.default)({
    desktopFiltersSpacer: { flexGrow: 1 },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.desktopFiltersSpacer }, props));
});
var DesktopFilterCheckboxContainer = (0, react_jss_1.default)(function (theme) { return ({
    desktopFilterCheckboxContainer: {
        flexDirection: "row",
        display: "flex",
        "& .checkboxRoot": {
            paddingBottom: theme.spacing.base,
            flexGrow: 1,
        },
        "& .tooltipIconRoot": {
            display: "flex",
            marginInlineStart: theme.spacing.base,
        },
    },
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.desktopFilterCheckboxContainer }, props));
});
var PopoverOverlay = (0, react_jss_1.default)({
    popoverOverlay: function (_a) {
        var isPopoverOpen = _a.isPopoverOpen;
        return ({
            height: "100%",
            width: "100vw",
            position: "fixed",
            top: 0,
            zIndex: 1500,
            display: isPopoverOpen ? "block" : "none",
        });
    },
})(function (_a) {
    var classes = _a.classes, isPopoverOpen = _a.isPopoverOpen, props = __rest(_a, ["classes", "isPopoverOpen"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.popoverOverlay }, props));
});
var FiltersButton = (0, react_jss_1.default)(function (theme) { return ({
    filtersButton: function (_a) {
        var highlightFiltersButton = _a.highlightFiltersButton;
        return ({
            "& button": __assign(__assign(__assign({ padding: "4px", border: "1px solid ".concat(theme.colors.baseContrast040), borderRadius: "2px" }, (highlightFiltersButton && { borderColor: "transparent" })), (highlightFiltersButton && { backgroundColor: theme.colors.primary })), { "& > svg, & > svg:hover": __assign({}, (highlightFiltersButton && {
                    fill: theme.mode === Theme_1.ThemeMode.light ? theme.colors.baseContrast020 : theme.colors.baseContrast080,
                })) }),
        });
    },
}); })(function (_a) {
    var classes = _a.classes, highlightFiltersButton = _a.highlightFiltersButton, props = __rest(_a, ["classes", "highlightFiltersButton"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.filtersButton }, props)));
});
var Link = (0, react_jss_1.default)(function (theme) { return ({
    link: {
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: 2,
        "&:hover": {
            cursor: "pointer",
            color: theme.colors.primary,
        },
        borderTop: "0px solid ".concat(theme.colors.baseContrast020),
        // eslint-disable-next-line @atg/css-rtl-support
        marginRight: "auto",
        flexShrink: 0,
    },
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.link }, props));
});
var FilterLink = (0, react_jss_1.default)(function (theme) { return ({
    filterLink: {
        fontSize: "18px",
        color: theme.colors.primary,
        cursor: "pointer",
        display: "flex",
        flexDirection: "row",
        letterSpacing: "0.19px",
        // eslint-disable-next-line @atg/css-rtl-support
        margin: "0 0 0 24px",
    },
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.filterLink }, props));
});
var Icon = (0, react_jss_1.default)({
    icon: {
        display: "inline-flex",
        marginTop: 0,
        marginBottom: "2px",
        marginInlineStart: "-4px",
        marginInlineEnd: "4px",
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.icon }, props));
});
var OnlineLinkContentContainer = (0, react_jss_1.default)(function (theme) { return ({
    onlineLinkContentContainer: {
        alignItems: "center",
        color: theme.colors.primary,
        cursor: "pointer",
        display: "flex",
        fontSize: theme.spacing.base * 2,
        letterSpacing: "0.17px",
    },
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.onlineLinkContentContainer }, props));
});
var CategoryScrollerContainer = (0, react_jss_1.default)(function () { return ({
    categoryScrollerContainer: {
        display: "flex",
    },
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.categoryScrollerContainer }, props));
});
var SearchResultsSectionHeader = /** @class */ (function (_super) {
    __extends(SearchResultsSectionHeader, _super);
    function SearchResultsSectionHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            desktopFilterOpen: null,
            currentTotalPerformers: null,
        };
        return _this;
    }
    SearchResultsSectionHeader.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
        var didStateOrPropsChange = !(0, EqualityComparers_1.deepEqualityComparer)(this.props, nextProps) || !(0, EqualityComparers_1.deepEqualityComparer)(this.state, nextState);
        if (!this.props.isLarge) {
            // limiting this to mobile because it breaks the desktop filters UX, but not mobile
            // and it helps save renders on mobile
            return this.props.path !== nextProps.path || (nextProps.hasInitialResults && didStateOrPropsChange);
        }
        return didStateOrPropsChange;
    };
    SearchResultsSectionHeader.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _a = this.props, filters = _a.filters, isOverFiltered = _a.isOverFiltered, setTotalPerformers = _a.setTotalPerformers, totalPerformers = _a.totalPerformers, isFirstGrid = _a.isFirstGrid;
        if (!filters || !isFirstGrid) {
            return; //nothing to do here
        }
        var currentTotalPerformers = undefined;
        if (!(0, AdvancedFilter_1.isAnyFilterChecked)(filters.advanced) || !(0, AdvancedFilter_1.isAnyFilterChecked)(prevProps.filters.advanced)) {
            currentTotalPerformers = undefined;
        }
        else if (totalPerformers) {
            // update the currentTotalPerformers count only if totalPerformers is a valid number
            // this avoids showing weird state while the data is loading.
            currentTotalPerformers = isOverFiltered ? undefined : totalPerformers;
        }
        if (currentTotalPerformers !== this.state.currentTotalPerformers) {
            setTotalPerformers === null || setTotalPerformers === void 0 ? void 0 : setTotalPerformers(currentTotalPerformers);
            this.setState({
                currentTotalPerformers: currentTotalPerformers,
            });
        }
    };
    SearchResultsSectionHeader.prototype._getFilteredCategoryGroups = function () {
        var _a;
        var categoryGroups = this.props.categoryGroups;
        return (_a = categoryGroups === null || categoryGroups === void 0 ? void 0 : categoryGroups.filter(function (_a) {
            var name = _a.name;
            return name !== CATEGORY_GROUP_TO_HIDE;
        })) !== null && _a !== void 0 ? _a : [];
    };
    SearchResultsSectionHeader.prototype._renderCategoryScroller = function () {
        var _a = this.props, isUserAuthenticated = _a.isUserAuthenticated, isLarge = _a.isLarge, categoryGroups = _a.categoryGroups, path = _a.path, isFirstGrid = _a.isFirstGrid, onlineOfflineMode = _a.onlineOfflineMode, genderFilter = _a.genderFilter, toggleSearch = _a.toggleSearch, theme = _a.theme, openMobileFilterModal = _a.openMobileFilterModal;
        var showCategoryScroller = !isLarge && isFirstGrid && categoryGroups;
        var filteredCategoryGroups = this._getFilteredCategoryGroups();
        if (showCategoryScroller) {
            return ((0, jsx_runtime_1.jsx)(CategoryScrollerContainer, { children: (0, jsx_runtime_1.jsx)(SearchResultsCategoryScroller_1.default, { "data-ta-locator": "SearchResultsCategoryScroller", categoryGroups: filteredCategoryGroups, genderFilter: genderFilter, openMobileFilterModal: openMobileFilterModal, isUserAuthenticated: isUserAuthenticated }) }));
        }
    };
    SearchResultsSectionHeader.prototype._renderOnlineOfflineLink = function (isFirstGrid) {
        var _a = this.props, onlineOfflineMode = _a.onlineOfflineMode, onOnlineButtonClicked = _a.onOnlineButtonClicked, translate = _a.translate, hideBackToOnlineLink = _a.hideBackToOnlineLink;
        if (hideBackToOnlineLink) {
            return null;
        }
        return (onlineOfflineMode === OnlineOfflineMode_1.ONLINE_OFFLINE_MODE_OFFLINE &&
            isFirstGrid && ((0, jsx_runtime_1.jsx)(Link, { onClick: onOnlineButtonClicked, "data-ta-locator": "SearchResultsSectionHeader-Link-back-to-online", children: (0, jsx_runtime_1.jsxs)(OnlineLinkContentContainer, { children: [(0, jsx_runtime_1.jsx)(Icon, { children: (0, jsx_runtime_1.jsx)(SvgIcon_1.default, { size: 16, name: "arrowBack", fill: "primary" }) }), translate("search.back_to_online")] }) })));
    };
    SearchResultsSectionHeader.prototype._renderDesktopFilters = function () {
        var _this = this;
        var _a = this.props, emitTrackingEvent = _a.emitTrackingEvent, eventPublisher = _a.eventPublisher, filters = _a.filters, onFilterChange = _a.onFilterChange, onThumbnailSizeChange = _a.onThumbnailSizeChange, shouldDisplayDropDowns = _a.shouldDisplayDropDowns, translate = _a.translate, thumbnailSize = _a.thumbnailSize, xmentService = _a.xmentService, ageVerificationRules = _a.ageVerificationRules;
        var newFilters = filters ? JSON.parse(JSON.stringify(filters)) : undefined;
        var showFiltersOnNewline = !!(shouldDisplayDropDowns && (newFilters === null || newFilters === void 0 ? void 0 : newFilters.advanced));
        var isTextBlurEnabled = ageVerificationRules === null || ageVerificationRules === void 0 ? void 0 : ageVerificationRules.isTextBlurEnabled;
        return ((0, jsx_runtime_1.jsxs)(DesktopFiltersContainer, { showFiltersOnNewline: showFiltersOnNewline, children: [showFiltersOnNewline && ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [newFilters.advanced
                            .filter(function (filter) { return !filter.isLocked; })
                            .filter(function (filter) { return (0, SearchFilters_1.filterByParentXment)(filter, xmentService); })
                            .map(function (filter) {
                            return ((0, jsx_runtime_1.jsxs)("div", { id: "desktopFilterContainer_".concat(filter.name), children: [(0, jsx_runtime_1.jsx)(FlatButton_1.default, { label: translate(filter.title), id: "desktopFilter_".concat(filter.name), "data-ta-locator": "desktopFilter_".concat(filter.name), overrides: {
                                            root: "flatButtonRoot",
                                            label: "flatButtonLabel",
                                        }, iconRight: (0, jsx_runtime_1.jsx)(SvgIcon_1.default, { name: "keyboardArrowDown" }), onClick: function () {
                                            emitTrackingEvent("icfClick", "desktopFilterButtonClick", "label=".concat(filter.name));
                                            if (_this.state.desktopFilterOpen === "desktopFilter_".concat(filter.name)) {
                                                _this.setState({ desktopFilterOpen: null });
                                                return;
                                            }
                                            _this.setState({
                                                desktopFilterOpen: "desktopFilter_".concat(filter.name),
                                            });
                                            // Send Loms event on filter open only
                                            if (eventPublisher) {
                                                eventPublisher.send(Events_1.Events.filterClick, {
                                                    desktop: true,
                                                    filter: filter.name,
                                                    option: null,
                                                    enabled: null,
                                                }, undefined, true);
                                            }
                                        } }), (0, jsx_runtime_1.jsx)(Popover_1.default, { targetId: "desktopFilter_".concat(filter.name), disableOpenOnHover: true, disableAnimation: !!_this.state.desktopFilterOpen, container: document.getElementById("desktopFilterContainer_".concat(filter.name)), open: _this.state.desktopFilterOpen === "desktopFilter_".concat(filter.name), staticPosition: true, overrides: {
                                            content: "popoverContent",
                                            root: "popoverRoot",
                                            triangle: "popoverTriangle",
                                        }, children: filter.options
                                            .filter(function (option) { return !option.isLocked; })
                                            .map(function (option) {
                                            var value = option.value, label = option.label, isChecked = option.isChecked, tip = option.tip;
                                            var blurLabel = Boolean(isTextBlurEnabled && filter.name.toLowerCase().includes(HeaderFilter.FETISHES));
                                            return ((0, jsx_runtime_1.jsxs)(DesktopFilterCheckboxContainer, { children: [(0, jsx_runtime_1.jsx)(Checkbox_1.default, { id: "desktopFilter-".concat(filter.name, "-").concat(value), "data-ta-locator": "desktopFilter-".concat(filter.name, "-").concat(value), onCheck: function () {
                                                            /* istanbul ignore next -- skipped test */
                                                            option.isChecked = !isChecked;
                                                            /* istanbul ignore next -- skipped test */
                                                            onFilterChange(newFilters);
                                                            /* istanbul ignore next -- skipped test */
                                                            if (eventPublisher) {
                                                                /* istanbul ignore next -- skipped test */
                                                                eventPublisher.send(Events_1.Events.filterClick, {
                                                                    desktop: true,
                                                                    filter: filter.name,
                                                                    option: value,
                                                                    enabled: !isChecked,
                                                                }, undefined, true);
                                                            }
                                                        }, name: filter.name, label: blurLabel ? (0, jsx_runtime_1.jsx)(HiddenText_1.HiddenText, { text: value, width: "8rem" }) : translate(label), checked: isChecked, overrides: { root: "checkboxRoot" }, "data-icf-click": "FilterCheckboxTop", "data-icf-meta": "label=".concat(filter.name, "-").concat(value) }), tip && !blurLabel && ((0, jsx_runtime_1.jsx)(Tooltip_1.default, { title: translate(tip), placement: _this.props.theme.direction === Theme_1.Direction.rtl
                                                            ? Tooltip_1.TooltipPlacement.LEFT
                                                            : Tooltip_1.TooltipPlacement.RIGHT, offset: 4, children: (0, jsx_runtime_1.jsx)(SvgIcon_1.default, { name: "help", size: 15, overrides: {
                                                                root: "tooltipIconRoot",
                                                            } }) }))] }, "desktopFilter-".concat(filter.name, "-").concat(value)));
                                        }) })] }, "desktopFilter-".concat(filter.name)));
                        }), (0, jsx_runtime_1.jsx)(PopoverOverlay, { id: "searchFiltersPopoverOverlay", "data-ta-locator": "searchFiltersPopoverOverlay", isPopoverOpen: !!this.state.desktopFilterOpen, onClick: function () { return _this.setState({ desktopFilterOpen: null }); } })] })), (0, jsx_runtime_1.jsx)(DesktopFiltersSpacer, {}), thumbnailSize && onThumbnailSizeChange && ((0, jsx_runtime_1.jsx)(SearchResultsSectionThumbnails_1.SearchResultsSectionThumbnails, { onThumbnailSizeChange: onThumbnailSizeChange, selectedSize: thumbnailSize }))] }));
    };
    SearchResultsSectionHeader.prototype._renderHeaderWrapper = function (message, totalPerformersText, isFirstGrid, className) {
        var _this = this;
        var _a = this.props, emitTrackingEvent = _a.emitTrackingEvent, filters = _a.filters, isLarge = _a.isLarge, refreshGrid = _a.refreshGrid, shouldDisplayDropDowns = _a.shouldDisplayDropDowns, toggleSearch = _a.toggleSearch, setCategoryGroupIndex = _a.setCategoryGroupIndex, setCurrentCategory = _a.setCurrentCategory, categoryGroups = _a.categoryGroups, categoryGroupIndex = _a.categoryGroupIndex, onlineOfflineMode = _a.onlineOfflineMode, setGenderPreference = _a.setGenderPreference, emitGenderTabEvent = _a.emitGenderTabEvent, isUserAuthenticated = _a.isUserAuthenticated, pushRoute = _a.pushRoute, path = _a.path, ageVerificationRules = _a.ageVerificationRules, blurCategoryLabel = _a.blurCategoryLabel, xmentService = _a.xmentService;
        // determine if we should show tabs
        var shouldShowTabs = isFirstGrid && categoryGroups && !isLarge;
        var newFilters = filters ? JSON.parse(JSON.stringify(filters)) : undefined;
        var showFiltersOnNewline = !!(shouldDisplayDropDowns && (newFilters === null || newFilters === void 0 ? void 0 : newFilters.advanced));
        var isTextBlurEnabled = ageVerificationRules === null || ageVerificationRules === void 0 ? void 0 : ageVerificationRules.isTextBlurEnabled;
        var renderGenderTabs = function () {
            var filteredCategoryGroups = _this._getFilteredCategoryGroups();
            if (filteredCategoryGroups.length === 1) {
                return null;
            }
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { style: { display: "flex" }, children: (0, jsx_runtime_1.jsx)(Tabs_1.default, { style: { flexGrow: "1" }, expand: true, value: categoryGroupIndex, children: filteredCategoryGroups.map(function (group, index) { return ((0, jsx_runtime_1.jsx)(Tabs_1.Tab, { label: _this.props.translate("categories.groups.".concat(group.name)), onClick: function () {
                                emitGenderTabEvent === null || emitGenderTabEvent === void 0 ? void 0 : emitGenderTabEvent(group.name);
                                pushRoute === null || pushRoute === void 0 ? void 0 : pushRoute("/browse/".concat(group.name, "/").concat(group.categories[0].name));
                                setGenderPreference === null || setGenderPreference === void 0 ? void 0 : setGenderPreference(filteredCategoryGroups[index].name);
                                setCategoryGroupIndex === null || setCategoryGroupIndex === void 0 ? void 0 : setCategoryGroupIndex(index);
                                setCurrentCategory === null || setCurrentCategory === void 0 ? void 0 : setCurrentCategory(filteredCategoryGroups[index].name);
                            }, selected: index === categoryGroupIndex }, group.name)); }) }) }) }));
        };
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [shouldShowTabs && renderGenderTabs(), isFirstGrid && this._renderCategoryScroller(), (0, jsx_runtime_1.jsxs)(HeaderWrapper, { isLarge: isLarge, isFirstGrid: isFirstGrid, showFiltersOnNewline: showFiltersOnNewline, children: [this._renderOnlineOfflineLink(isFirstGrid), (!isFirstGrid || isLarge) && ((0, jsx_runtime_1.jsx)(SearchResultsSectionHeaderMessage_1.SearchResultsSectionHeaderMessage, { className: className, emitTrackingEvent: emitTrackingEvent, isFirstHeader: false, isLarge: isLarge, message: message, onRefreshClicked: refreshGrid, onMessageClicked: toggleSearch, totalPerformersText: totalPerformersText, blur: isTextBlurEnabled && blurCategoryLabel })), isFirstGrid !== false && ((0, jsx_runtime_1.jsx)(HeaderFiltersContainer, { isLarge: isLarge, showFiltersOnNewline: showFiltersOnNewline, children: isLarge && this._renderDesktopFilters() }))] })] }));
    };
    SearchResultsSectionHeader.prototype.render = function () {
        var _a = this.props, emitTrackingEvent = _a.emitTrackingEvent, fallback = _a.fallback, filters = _a.filters, isFirstGrid = _a.isFirstGrid, isLarge = _a.isLarge, message = _a.message, onlineOfflineMode = _a.onlineOfflineMode, onOfflineButtonClicked = _a.onOfflineButtonClicked, onOnlineButtonClicked = _a.onOnlineButtonClicked, onRemoveFilter = _a.onRemoveFilter, noResultsMessage = _a.noResultsMessage, resultsMessage = _a.resultsMessage, totalPerformersText = _a.totalPerformersText, path = _a.path;
        var messageContainerClassName = fallback ? "search-no-results" : "search-results-success";
        var showSuccessfulSearchMessage = ((path === null || path === void 0 ? void 0 : path.startsWith("/search")) || (path === null || path === void 0 ? void 0 : path.startsWith("/tag"))) && !isLarge && isFirstGrid;
        return ((0, jsx_runtime_1.jsxs)("div", { "data-ta-locator": "search-results-header", children: [this._renderHeaderWrapper(message, totalPerformersText, isFirstGrid, messageContainerClassName), isFirstGrid && ((0, jsx_runtime_1.jsx)(FilterPillHeaderContainer_1.FilterPillHeaderContainer, { filters: filters, onRemoveFilter: 
                    /* istanbul ignore next -- TODO: handle fallback through context */
                    onRemoveFilter !== null && onRemoveFilter !== void 0 ? onRemoveFilter : (function () {
                        /* no-op */
                    }), emitTrackingEvent: emitTrackingEvent, isMobile: !isLarge, onOnlineButtonClicked: 
                    /* istanbul ignore next -- TODO: handle no-op fallback through context */
                    onOnlineButtonClicked !== null && onOnlineButtonClicked !== void 0 ? onOnlineButtonClicked : (function () {
                        /* no-op */
                    }) })), fallback ? ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Text_1.default, { "data-ta-locator": "SearchResults-OverFilteredMessage", color: "baseContrast060", margin: "6 8 2 8", children: noResultsMessage }), onlineOfflineMode === OnlineOfflineMode_1.ONLINE_OFFLINE_MODE_ONLINE && ((0, jsx_runtime_1.jsx)(ShowOfflineButtonContainer_1.ShowOfflineButtonContainer, { onClick: onOfflineButtonClicked })), this._renderHeaderWrapper(fallback.message, fallback.totalPerformersText, false, messageContainerClassName)] })) : (showSuccessfulSearchMessage && ((0, jsx_runtime_1.jsx)(Text_1.default, { "data-ta-locator": "SearchResults-OverFilteredMessage", color: "baseContrast060", margin: "6 8 6 8", children: resultsMessage })))] }));
    };
    return SearchResultsSectionHeader;
}(react_1.default.Component));
exports.SearchResultsSectionHeader = SearchResultsSectionHeader;
//# sourceMappingURL=SearchResultsSectionHeader.js.map